var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('catalogue-categories-table')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-content-between"},[_c('div',[_c('h4',[_vm._v("Catalogue Categories")])])])
}]

export { render, staticRenderFns }